import {usePatientContext} from '@/shared/contexts/patient-context'
import {Avatar, Box, Flex, Text, HStack} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuUser} from 'react-icons/lu'

export function PatientSummary() {
  const {patient} = usePatientContext()
  const {t} = useTranslate()
  return (
    <Flex paddingY="4" alignItems="flex-start" justifyContent="space-between" width="100%">
      <HStack gapX="3">
        <Avatar.Root size="xl" shape="square" rounded="md">
          <LuUser size="1.5rem" />
        </Avatar.Root>
        <Box>
          <Text fontSize="lg" fontWeight="medium">
            {`${patient.givenName} ${patient.familyName}`}
          </Text>
          <Text fontSize="xs" fontWeight="normal" color="fg.muted">
            {t('last_checked', {date: 'Today'})}
          </Text>
        </Box>
      </HStack>
    </Flex>
  )
}
